import { useState, useEffect } from "react";

const usePasswordValidation = (initialValue = "") => {
  const [password, setPassword] = useState(initialValue);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    setIsValid(validatePassword(password));
  }, [password]);

  const validatePassword = (password) => {
    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!?*]).{8,20}$/;
    return pattern.test(password);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  return {
    value: password,
    isValid,
    handleChange: handlePasswordChange,
  };
};

export default usePasswordValidation;
